export default __webpack_public_path__ + "cdb1aff2161b741da43effc75da1ca9b.png";